export const VolumeUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.5355 14.0103C13.0737 12.4721 14.0251 10.3471 14.0251 7.99991C14.0251 5.6527 13.0737 3.5277 11.5355 1.9895L10.8284 2.69661C12.1857 4.05384 13.0251 5.92884 13.0251 7.99991C13.0251 10.071 12.1857 11.946 10.8284 13.3032L11.5355 14.0103Z"
      fill="currentColor"
    />
    <path
      d="M10.1213 12.5961C11.2976 11.4198 12.0251 9.79484 12.0251 7.99991C12.0251 6.20498 11.2976 4.57998 10.1213 3.40372L9.41421 4.11082C10.4095 5.10613 11.0251 6.48113 11.0251 7.99991C11.0251 9.51869 10.4095 10.8937 9.41421 11.889L10.1213 12.5961Z"
      fill="currentColor"
    />
    <path
      d="M8.70711 11.1819C9.52145 10.3676 10.0251 9.24255 10.0251 7.99991C10.0251 6.75727 9.52145 5.63227 8.70711 4.81793L8 5.52504C8.63338 6.15841 9.02513 7.03341 9.02513 7.99991C9.02513 8.96641 8.63338 9.84141 8 10.4748L8.70711 11.1819Z"
      fill="currentColor"
    />
    <path
      d="M6.71659 3.54926C6.88983 3.63252 7 3.80771 7 3.99991V11.9999C7 12.1921 6.88983 12.3673 6.71659 12.4506C6.54336 12.5338 6.33774 12.5104 6.18765 12.3903L3.82461 10.4999H1.5C1.22386 10.4999 1 10.2761 1 9.99991V5.99991C1 5.72377 1.22386 5.49991 1.5 5.49991H3.82461L6.18765 3.60948C6.33774 3.48941 6.54336 3.466 6.71659 3.54926Z"
      fill="currentColor"
    />
  </svg>
);
